import React from "react";

export default function MindPodcast() {
  return (
    <div className="max-w-6xl mx-auto pt-4 space-y-6">
      <h2 className="px-3 text-3xl text-center mt-6 font-bold">
        Harmony for the Mind
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/album/4WJlT8rSyf9nf0YrdKriSO?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/show/2BLdPSFfzWaYKiXYV0Nqvo?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/episode/6Lei7wvK0bDVCajZHkkWqn?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/episode/4BNGWe69Pw8k1Q9EIQtzGI?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/show/2kH3ec1ljTia7VmwYsm8Xt?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/show/4298EkFJWEK6VAxKARB7bS?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/show/5UsxoX6ikTr3ETvzQAHbdP?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/show/571TfkIrKfbMXse360yYfT?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/show/4W5LEoAIELfsrFgF5rAoEM?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/episode/0jRwe28uDWTxcVg86pS4qR?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/show/3HWnUfK8VXBXVnrtJS7eAR?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
        <div className="p-4">
        <iframe
          class="rounded-lg"
          src="https://open.spotify.com/embed/episode/6CmtgiGDJum4cJUmxjhRwZ?utm_source=generator&theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
        </div>
      </div>
    </div>
  );
}
